import React from 'react'
import { FormInput } from '../../../shared/ui/formInput'
import { determineInputType } from '../lib/determineInputType'
import { FieldArrayWithId } from 'react-hook-form'
import { TFormValues } from '../productForm.types'
import { storeIntegrationKeyByType } from '../../../../types/integrationTypeUtils'
import { IntegrationType } from '../../../../server/mpsklad_core/Entity/IntegrationType'
import { FormAutoselect } from '../../../shared/ui/formAutoSelect'
import { useAttributeDiff } from '../lib/attributeDiffContext'
import { FormRichTextEditor } from '../../../shared/ui/formRichTextEditor'

// NOTE: This component is designed for use inside ProductForm only.
// Its main purpose is to prevent unnecessary re-renders of form fields by using React.memo.
// This improves form performance, especially in dynamic lists.

type AttributeFieldProps = {
  name: string
  attr: FieldArrayWithId<TFormValues, 'attributes', 'id'>;
  as?: 'textArea' | 'input' | 'autoselect'
};

export const AttributeField: React.FC<AttributeFieldProps> = React.memo(
  ({name, attr, as = 'input'}) => {
    const diffMap = useAttributeDiff()
    const oldValue = diffMap?.get(attr.id)
    const isChanged = !!oldValue

    if (as === 'autoselect') {
      return <FormAutoselect
        name={name}
        label={attr.name}
        options={[
          ...(attr.isRequired ? [] : [{value: '', label: 'Не выбрано'}]),
          ...attr.enumValues.map((val: string) => ({value: val, label: val}))
        ]}
        required={attr.isRequired}
        types={!attr.integrationType || attr.integrationType === IntegrationType.MoySklad
               ? 'universal'
          : [storeIntegrationKeyByType[attr.integrationType]]}
        description={attr.description}
      />
    }

    if (as === 'input') {
      return <FormInput
        name={name}
        label={attr.name}
        required={attr.isRequired}
        types={!attr.integrationType || attr.integrationType === IntegrationType.MoySklad
               ? 'universal'
               : [storeIntegrationKeyByType[attr.integrationType]]}
        type={determineInputType(attr.type)}
        marketplaceValue={isChanged ? oldValue : undefined}
        description={attr.description}
      />
    }

    if (as === 'textArea') {
      return <FormRichTextEditor
        name={name}
        label={attr.name}
        types={'universal'}
        required={attr.isRequired}
        description={attr.description}
        marketplaceValue={isChanged ? oldValue : undefined}
      />
    }

    return <></>
  }
)